import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as techApi from '../../lib/api/tech';

const [VIEW_PROJECT, VIEW_PROJECT_SUCCESS, VIEW_PROJECT_FAILURE] =
  createRequestActionTypes('tech/VIEW_PROJECT');
export const viewProject = createAction(VIEW_PROJECT, (id) => id);
const viewProjectSaga = createRequestSaga(VIEW_PROJECT, techApi.getProject);

const UNLOAD_PROJECT = 'tech/UNLOAD_PROJECT';
export const unloadProject = createAction(UNLOAD_PROJECT);

const SET_PROJECT = 'tech/SET_PROJECT';
export const setProject = createAction(SET_PROJECT, (tech) => tech);


export function* projectSaga() {
  yield takeLatest(VIEW_PROJECT, viewProjectSaga);
}

const initialState = {
  project: null,
  error: null,
};

const project = handleActions(
  {
    [VIEW_PROJECT_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      project: data.info,
    }),
    [VIEW_PROJECT_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [UNLOAD_PROJECT]: () => initialState,
    [SET_PROJECT]: (state, { payload: project }) => ({
      ...state,
      project: project,
    }),
    
  },
  initialState,
);

export default project;
